import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApplicationConfigurationService } from "@app/core/services/ApplicationConfiguration.service";
import { HearingHistoryEntry } from "../models/hearing-history.model";

const BASE_PATH = "/api/phms/incarcerated-persons";

const quietHttpOptions = {
  headers: new HttpHeaders({
    "skip-error-interceptor": "yes",
    "skip-loading-interceptor": "yes",
  }),
  withCredentials: true,
};

@Injectable({ providedIn: "root" })
export class HearingHistoryService {
  private readonly http = inject(HttpClient);
  private readonly appConfig = inject(ApplicationConfigurationService);

  getHearingHistory(incarceratedPersonId: number): Observable<HearingHistoryEntry[]> {
    return this.http.get<HearingHistoryEntry[]>(
      this.appConfig.apiUrl(`${BASE_PATH}/${encodeURIComponent(String(incarceratedPersonId))}/hearing-history`),
      quietHttpOptions,
    );
  }
}
